import { useEffect, useState, useMemo } from "react";
import {
  Card,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Box,
  Tab,
  Tabs,
} from "@material-ui/core";
import LoadingButton from "@mui/lab/LoadingButton";
import BigNumber from "bignumber.js";
import { RootState, RootDispatch } from "../../model";
import { useRematch } from "../../utils/useRematch";
import petsBanner from "../../assets/pets-banner.jpg";
import petsMin from "../../assets/pets-min.jpg";
import petsFight from "../../assets/pets-fight.jpg";
import "./index.less";

const mapState = (state: RootState) => ({
  ...state.main,
  ...state.pets,
  loading: state.loading,
});

const mapDispatch = (dispatch: RootDispatch) => ({
  ...dispatch.pets,
});

export default function Pets() {
  const [
    { isMainNet, alertState, ethersProvider, signer, loading },
    { roleClaim, lootClaim, mlootClaim, mintPets, initPetsContract },
  ] = useRematch(mapState, mapDispatch);

  const [showRulesModal, setShowRulesModal] = useState(false);
  const [value, setValue] = useState(0);
  const [lootTokenId, setLootTokenId] = useState("");
  const [lootClaimTokenId, setLootClaimTokenId] = useState("");
  const [mlootTokenId, setMlootTokenId] = useState("");
  const [mlootClaimTokenId, setMlootClaimTokenId] = useState("");
  const [mintTokenId, setMintTokenId] = useState("");

  return (
    <div className="pets">
      <Dialog
        open={showRulesModal}
        onClose={() => {
          setShowRulesModal(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          About the Claim Rules?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <span className="rule-desc">
              <b>About Pets:</b> <br />
              1. The mode of this project learned a lot from Dungeons & Dragons
              (DND). <br />
              <br />
              2. Pets have 6 Sizes, 6 Attributes, 11 Class, 9 alignment, 317
              seed professions and 266 Traits. <br />
              <br />
              3. There are a total of 20,000 Pets, of which 10,000 can be
              created for free (Token ID：1-10000) by the owners of [Role] in
              five days (2000 per day), 2000 can be created for free (Token
              ID：10001-12000) by the owners of [Loot] in five days (400 per
              day), 2000 can be created for free (Token ID：12001-14000) by the
              owners of [mLoot] in five days (400 per day), 5000 can be created
              for 0.01 ETH (Token ID：14001-19000) in the official website (
              <a href="https://www.roleformetaverse.club/#/">
                https://www.roleformetaverse.club/#/
              </a>
              )in five days (1000 per day), 1000 (Token ID：19001-20000) belong
              to the development team. <br />
              <br />
              4. For those Paid to mint pets, If any one of them are left
              Unminted after sales in 10 days, it will get burnt FOREVER. <br />
              <br />
              5. Pets will charge 3% of the secondary royalties. As a gesture of
              respect and support, part of Pets’ revenue will be used to collect
              floor price Role.
            </span>
            <br />
            <br />
            <span className="rule-desc">
              <b>What is the relationship among [Pets], [Role] and [Loot]? </b>
              <br />
              1. Pets will evolve with [Role] and [Loot], the key intermediate
              in uniting the two into a complete [Role+]. <br />
              <br />
              2. The evolution of [Role+] happens only when the owners combined
              [Pets], [Role] and certified [Loot] project (incl. [Loot],
              [mLoot], etc., in terms of future partnerships decided by
              community). Remember that each [Pets] or certified [Loot] project
              can pay homage (i.e. used in the evolution) to [Role] ONCE ONLY.
              More detailed plans about [Role+] will be released soon (). <br />
              <br />
              3. Pets will be mostly created by the Holly Owners of [Role],
              while others will be created by the Holly owners of [Loot]. Pets’
              Attributes, Alignment, Sizes, Species, Trait, and Class are
              randomly generated by the contract.
            </span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowRulesModal(false);
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid item xs={10} md={4} justifyContent="center">
          <div className="title">
            <div className="pets-icon">
              <img src={petsMin} width="100%" alt="" />
            </div>
            {/* <div className="remaining-count">
              498 <sup>Remaining</sup>
            </div> */}
          </div>
          <div className="desc">
            Pets are about love. The companionate love that helps your Role
            evolve and adapt into the future Loot ecosystem. Pets are about
            courage, the courage that pathfinders will rely on as they explore
            the Metaverse in pursuit of what Role sets fire to.
          </div>
          <div className="card">
            <img src={petsFight} width="100%" alt="" />
          </div>
          <div className="rules-button">
            <Button
              variant="contained"
              color="primary"
              fullWidth
              // className="rules-button"
              size="large"
              onClick={() => {
                setShowRulesModal(true);
              }}
            >
              Claim Rules
            </Button>
          </div>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={(event, newValue) => {
                  setValue(newValue);
                }}
                style={{ color: "#858c94" }}
                scrollButtons="auto"
                variant="scrollable"
                textColor="secondary"
                indicatorColor="secondary"
                aria-label="basic tabs example"
              >
                <Tab label="Role Claim" />
                <Tab label="loot Claim" />
                <Tab label="mloot Claim" />
                <Tab label="Mint" />
              </Tabs>
            </Box>
            {value === 0 && (
              <Card className="mint-card">
                <div className="button">
                  <LoadingButton
                    loading={loading.effects.pets.roleClaim}
                    loadingIndicator="Pending..."
                    variant="contained"
                    className="mint-button"
                    color="secondary"
                    fullWidth
                    disabled={loading.effects.pets.roleClaim}
                    onClick={() => {
                      roleClaim();
                    }}
                  >
                    Role Claim
                  </LoadingButton>
                </div>
              </Card>
            )}
            {value === 1 && (
              <Card className="mint-card">
                <TextField
                  // error={
                  //   new BigNumber(lootTokenId).isNaN() ||
                  //   new BigNumber(lootTokenId).isInteger()
                  // }
                  className="token-input"
                  color="secondary"
                  style={{ color: "#fff" }}
                  type="text"
                  variant="outlined"
                  value={lootTokenId}
                  onChange={(e) => {
                    setLootTokenId(e.target.value);
                  }}
                  label="loot Token ID"
                  fullWidth
                  // helperText={
                  //   new BigNumber(lootTokenId).isNaN() ||
                  //   new BigNumber(lootTokenId).isInteger()
                  //     ? "Invalid Token ID."
                  //     : ""
                  // }
                />
                <TextField
                  // error={
                  //   new BigNumber(lootClaimTokenId).isNaN() ||
                  //   new BigNumber(lootClaimTokenId).isInteger()
                  // }
                  className="token-input"
                  color="secondary"
                  style={{ color: "#fff", marginTop: "16px" }}
                  type="text"
                  variant="outlined"
                  value={lootClaimTokenId}
                  onChange={(e) => {
                    setLootClaimTokenId(e.target.value);
                  }}
                  label="Claim Pets Token ID (Vaild 10000-12000)"
                  fullWidth
                  // variant="outlined"
                  // helperText={
                  //   new BigNumber(lootClaimTokenId).isNaN() ||
                  //   new BigNumber(lootClaimTokenId).isInteger()
                  //     ? "Invalid Token ID."
                  //     : ""
                  // }
                />
                <div className="button">
                  <LoadingButton
                    loading={loading.effects.pets.lootClaim}
                    loadingIndicator="Pending..."
                    variant="contained"
                    className="mint-button"
                    color="secondary"
                    fullWidth
                    disabled={
                      new BigNumber(lootClaimTokenId).isNaN() ||
                      !new BigNumber(lootClaimTokenId).isInteger() ||
                      new BigNumber(lootTokenId).isNaN() ||
                      !new BigNumber(lootTokenId).isInteger() ||
                      loading.effects.pets.lootClaim
                    }
                    onClick={() => {
                      lootClaim({
                        lootId: new BigNumber(lootTokenId).toNumber(),
                        tokenId: new BigNumber(lootClaimTokenId).toNumber(),
                      });
                    }}
                  >
                    loot Claim
                  </LoadingButton>
                </div>
              </Card>
            )}
            {value === 2 && (
              <Card className="mint-card">
                <TextField
                  // error={
                  //   new BigNumber(mlootTokenId).isNaN() ||
                  //   new BigNumber(mlootTokenId).isInteger()
                  // }
                  className="token-input"
                  color="secondary"
                  style={{ color: "#fff" }}
                  type="text"
                  variant="outlined"
                  value={mlootTokenId}
                  onChange={(e) => {
                    setMlootTokenId(e.target.value);
                  }}
                  label="mloot Token ID"
                  fullWidth
                  // helperText={
                  //   new BigNumber(mlootTokenId).isNaN() ||
                  //   new BigNumber(mlootTokenId).isInteger()
                  //     ? "Invalid Token ID."
                  //     : ""
                  // }
                />
                <TextField
                  // error={
                  //   new BigNumber(mlootClaimTokenId).isNaN() ||
                  //   new BigNumber(mlootClaimTokenId).isInteger()
                  // }
                  className="token-input"
                  color="secondary"
                  style={{ color: "#fff", marginTop: "16px" }}
                  type="text"
                  variant="outlined"
                  value={mlootClaimTokenId}
                  onChange={(e) => {
                    setMlootClaimTokenId(e.target.value);
                  }}
                  label="Claim Pets Token ID (Vaild 12001-14000)"
                  fullWidth
                  // variant="outlined"
                  // helperText={
                  //   new BigNumber(mlootClaimTokenId).isNaN() ||
                  //   new BigNumber(mlootClaimTokenId).isInteger()
                  //     ? "Invalid Token ID."
                  //     : ""
                  // }
                />
                <div className="button">
                  <LoadingButton
                    loading={loading.effects.pets.mlootClaim}
                    loadingIndicator="Pending..."
                    variant="contained"
                    className="mint-button"
                    color="secondary"
                    fullWidth
                    disabled={
                      !new BigNumber(mlootClaimTokenId).isInteger() ||
                      new BigNumber(mlootTokenId).isNaN() ||
                      !new BigNumber(mlootTokenId).isInteger() ||
                      loading.effects.pets.lootClaim
                    }
                    onClick={() => {
                      mlootClaim({
                        lootId: new BigNumber(mlootTokenId).toNumber(),
                        tokenId: new BigNumber(mlootClaimTokenId).toNumber(),
                      });
                    }}
                  >
                    mloot Claim
                  </LoadingButton>
                </div>
              </Card>
            )}
            {value === 3 && (
              <Card className="mint-card">
                <TextField
                  error={
                    new BigNumber(mintTokenId).isNaN() ||
                    new BigNumber(mintTokenId).isLessThanOrEqualTo(14000) ||
                    new BigNumber(mintTokenId).isGreaterThan(19000)
                  }
                  className="token-input"
                  color="secondary"
                  style={{ color: "#fff" }}
                  type="text"
                  variant="outlined"
                  value={mintTokenId}
                  onChange={(e) => {
                    setMintTokenId(e.target.value);
                  }}
                  label="Token ID(Vaild 14001-19000)"
                  placeholder="Token ID"
                  fullWidth
                  // variant="outlined"
                  helperText={
                    new BigNumber(mintTokenId).isLessThanOrEqualTo(14000) ||
                    new BigNumber(mintTokenId).isGreaterThan(19000)
                      ? "Token ID invalid."
                      : ""
                  }
                />
                <div className="button">
                  <LoadingButton
                    loading={loading.effects.pets.mintPets}
                    loadingIndicator="Pending..."
                    variant="contained"
                    className="mint-button"
                    color="secondary"
                    fullWidth
                    disabled={
                      new BigNumber(mintTokenId).isNaN() ||
                      new BigNumber(mintTokenId).isLessThanOrEqualTo(14000) ||
                      new BigNumber(mintTokenId).isGreaterThan(19000) ||
                      loading.effects.pets.mintPets
                    }
                    onClick={() => {
                      mintPets(new BigNumber(mintTokenId).toNumber());
                    }}
                  >
                    Mint
                  </LoadingButton>
                </div>
              </Card>
            )}
          </Box>
        </Grid>
        <Grid item xs={10} md={8}>
          <div className="pets-banner">
            <img src={petsBanner} width="100%" height="100%" alt="" />
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
